import { useRouter } from 'next/router';

export const useInnerTabs = (innerTabs, key = 'inner-tab') => {
  const { query, pathname, replace } = useRouter();

  const handleChangeTab = (event, newValue) => {
    const queryKey = innerTabs?.[newValue]?.key;

    if (!queryKey) return;

    replace(
      {
        pathname,
        query: {
          ...query,
          [key]: queryKey,
        },
      },
      undefined,
      { shallow: true }
    );
  };
  const selectedTabIndex = innerTabs.findIndex(
    (item) => item.key === query?.[key]
  );

  return { handleChangeTab, selectedTabIndex };
};

export default useInnerTabs;
